module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "nonprofit-modal-msg"
  }), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: " padding-left col-lg-11 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "no-margin-bot"
  }, [_vm._v("EVF launched the Changing Life through Lenses® (CLTL) Relief Fund to help support and expand the charitable efforts of doctors and nonprofits in response to the increasing need. CLTL participants who provide vision services to Eligible Patients between June 1 through December 31, 2021, can receive funds of up to $1,500.\n"), _c('b', [_c('router-link', {
    attrs: {
      "to": {
        name: 'CovidReliefRegistration'
      },
      "target": "_blank"
    }
  }, [_vm._v("Learn More ")])], 1), _c('br')]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom"
  }, [_c('label', {
    staticClass: "radio form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CovidReliefParticipantStatus),
      expression: "CovidReliefParticipantStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "yesiwant",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.CovidReliefParticipantStatus, "yes")
    },
    on: {
      "change": function($event) {
        _vm.CovidReliefParticipantStatus = "yes"
      }
    }
  }), _vm._v("\n                                        I AGREE and am interested in participating in CLTL Relief.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CovidReliefParticipantStatus),
      expression: "CovidReliefParticipantStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "nothanks",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.CovidReliefParticipantStatus, "no")
    },
    on: {
      "change": function($event) {
        _vm.CovidReliefParticipantStatus = "no"
      }
    }
  }), _vm._v("\n                                        I DISAGREE and am not interested in participating in CLTL Relief."), _c('br'), _vm._v(" "), ((_vm.CovidReliefParticipantStatus == 'no')) ? _c('small', [_vm._v(" No problem, if you change your mind, you can enroll later on the Resources page.")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CovidReliefParticipantStatus),
      expression: "CovidReliefParticipantStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "remindLater",
      "value": "remindLater"
    },
    domProps: {
      "checked": _vm._q(_vm.CovidReliefParticipantStatus, "remindLater")
    },
    on: {
      "change": function($event) {
        _vm.CovidReliefParticipantStatus = "remindLater"
      }
    }
  }), _vm._v("\n                                        I am not ready to decide right now, remind me later.                                        "), ((_vm.CovidReliefParticipantStatus == 'remindLater')) ? _c('small', [_c('br'), _vm._v(" No problem, we'll show you this screen again next time you login.")]) : _vm._e()]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p')])]), _vm._v(" "), (_vm.isFormLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "disabled": !(_vm.CovidReliefParticipantStatus.trim() != '' ? true : false),
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitCRPS()
      }
    }
  }, [_vm._v("Submit")])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_c('div', [_vm._v("\nChanging Life through Lenses® Relief Fund (Limited Time Only!)\n                                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("                                    Select I AGREE and Submit below to complete your registration for Relief!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "g-font-size-18--md g-font-size-16"
  }, [_c('small', [_c('li', [_vm._v("Relief is intended to help support costs for vision services including identifying, qualifying and examining Eligible Patients that result in glasses ordered on changinglifethroughlenses.org; orders of second pairs for one Eligible Patient will not count for two patients")]), _vm._v(" "), _c('li', [_vm._v("Participant will not bill Medicare, Medicaid and other Federal health care programs or third party insurers for services supported by this Relief.")]), _vm._v(" "), _c('li', [_vm._v("Relief amount is based on vision services supporting (Tier 1 - $150): 2 or more, (Tier 2 - $900): 12 or more or (Tier 3 - $1,500): 20 or more Eligible Patients with payment contingent upon completion of survey and W9.")]), _vm._v(" "), _c('li', [_c('b', [_c('a', {
    attrs: {
      "href": "https://drive.google.com/file/d/1tR14hA3fqKN0fGNrCHlqf-SW_Kuk7gJg/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("Click here")])]), _vm._v(" for Terms and Conditions")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-217e077d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217e077d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDetails/CovidRelief.vue
// module id = 468
// module chunks = 3